import React from "react";
import { Twitter } from "@mui/icons-material";
import { Box, Grid, MenuItem } from "@mui/material";
import CustomTextField from "../../../../../components/ui/Textfield";
import { RegistryPage } from "../../registry/sitePageRegistry";
import { SEOForm } from "../../types";
import SectionCard from "./SectionCard";
import TemplateInput from "./TemplateInput";

interface TwitterCardCardProps {
  form: SEOForm;
  onChange: <K extends keyof SEOForm>(field: K, value: SEOForm[K]) => void;
  pageDefinition?: RegistryPage;
}

const TwitterCardCard: React.FC<TwitterCardCardProps> = ({ form, onChange, pageDefinition }) => {
  const variables = pageDefinition?.isDynamic ? pageDefinition.variables ?? [] : [];

  return (
    <SectionCard icon={<Twitter color="primary" />} title="Twitter / X Card">
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }}>
          <TemplateInput
            label="Twitter Title"
            value={form.twitterTitle}
            onChange={(next) => onChange("twitterTitle", next)}
            variables={variables}
            placeholder={form.ogTitle || form.metaTitle}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <TemplateInput
            multiline
            label="Twitter Description"
            value={form.twitterDescription}
            onChange={(next) => onChange("twitterDescription", next)}
            variables={variables}
            placeholder={form.ogDescription || form.metaDescription}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <CustomTextField
            label="Twitter Image"
            value={form.twitterImageUrl}
            onChange={(event) => onChange("twitterImageUrl", event.target.value)}
            placeholder={form.ogImageUrl}
          />
        </Grid>
        {(form.twitterImageUrl || form.ogImageUrl) && (
          <Grid size={{ xs: 12 }}>
            <Box
              component="img"
              src={form.twitterImageUrl || form.ogImageUrl}
              alt="Twitter card preview"
              sx={{ width: "100%", maxHeight: 220, objectFit: "cover", borderRadius: 2 }}
              onError={(event) => {
                (event.target as HTMLImageElement).style.display = "none";
              }}
            />
          </Grid>
        )}
        <Grid size={{ xs: 12, md: 4 }}>
          <CustomTextField
            select
            label="Card Type"
            value={form.twitterCardType}
            onChange={(event) => onChange("twitterCardType", event.target.value)}
          >
            <MenuItem value="summary">Summary</MenuItem>
            <MenuItem value="summary_large_image">Large image</MenuItem>
            <MenuItem value="player">Player</MenuItem>
            <MenuItem value="app">App</MenuItem>
          </CustomTextField>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <CustomTextField
            label="Twitter Site"
            value={form.twitterSite}
            onChange={(event) => onChange("twitterSite", event.target.value)}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <CustomTextField
            label="Twitter Creator"
            value={form.twitterCreator}
            onChange={(event) => onChange("twitterCreator", event.target.value)}
          />
        </Grid>
      </Grid>
    </SectionCard>
  );
};

export default TwitterCardCard;
